import React               from 'react';
import PlaceItem           from './PlaceItem';
import { ListItem }        from 'material-ui/List';
import Avatar              from 'material-ui/Avatar';
import Trail               from 'material-ui/svg-icons/maps/directions-walk';
import Place               from 'material-ui/svg-icons/communication/location-on';

class PlaceListItem extends PlaceItem
{
    render = () =>
    {
        let { place } = this.props;

        let icon;
        let dummyIcon = ('trail' === place.type) ? <Trail/> : <Place/>;

        if (0 === place.icon.length)
        {
            icon = <Avatar icon={ dummyIcon } />;
        }
        else
        {
            icon = <Avatar src={ place.icon } />
        }

        return (
            <ListItem
                leftAvatar={ icon }
                onTouchTap={ this.resolveClickEvent(place).bind(this, place) }
                primaryText={ place.name }
                secondaryText={ this.resolveIntro(place) }
                secondaryTextLines={ 2 }
            />
        );
    }

}

export default PlaceListItem;


// WEBPACK FOOTER //
// ./src/components/PlaceListItem.js